import React, { Suspense } from "react"
import Authentication from "components/authentication"
import { Navigate } from "react-router-dom"
import ProtectedRoute from "../components/common/protectedRoute/ProtectedRoute"

const SummaryPage = React.lazy(()=> import("../components/waste_overview/deep_dive/design_to_distribute/summary/summary"))
const WasteOverview = React.lazy(
  () => import("../components/waste_overview/deep_dive"),
)

const Summary = React.lazy(
  () =>
    import(
      "../components/waste_overview/deep_dive/design_to_distribute/summary/summary"
    ),
)
const InterventionCenter = React.lazy(
  () => import("../components/intervention_centre"),
)
const RegisteredInterventionCenter = React.lazy(
  () => import("../components/registered_intervention/registeredIntervention"),
)
const AISuggestions = React.lazy(
  () => import("../components/ai_intervention/aiIntervention"),
)
const AiOptions = React.lazy(
  () => import("../components/ai_intervention/ai_options/aiOptions"),
)
const PowerBIUI = React.lazy(
  () => import("../components/waste_overview/powerBI/index"),
)
const RegisteredOptions = React.lazy(
  () =>
    import(
      "../components/registered_intervention/registered_options/registeredOptions"
    ),
)
const Landing = React.lazy(() => import("../components/landing/Landing"))

const CountryDropdown = React.lazy(() => import("../components/common/countryDropdown/CountryDropdown"));


const authProtectedRoutes = [
  // Country selection route - NOT protected (users can access without selection)
  {
    path: "/country-selection",
    element: (
      <React.Suspense fallback={null}>
        <CountryDropdown/>
      </React.Suspense>
    ),
    breadcrumb: {
      label: "Country Selection",
    },
  },
  // All other routes - PROTECTED (require country selection)
  {
    path: "/service",
    element: (
      <React.Suspense fallback={null}>
        <ProtectedRoute>
          <Landing />
        </ProtectedRoute>
      </React.Suspense>
    ),
    breadcrumb: {
      label: "Service Command Center",
    },
  },
  {
    path: "/intervention_centre",
    element: (
      <React.Suspense fallback={null}>
        <ProtectedRoute>
          <InterventionCenter />
        </ProtectedRoute>
      </React.Suspense>
    ),
    breadcrumb: {
      label: "Intervention Center",
    },
  },
  {
    path: "/registered_Intervention/option/:InterventionRegistration_ID/:registeredBy",
    element: (
      <React.Suspense fallback={null}>
        <ProtectedRoute>
          <RegisteredOptions />
        </ProtectedRoute>
      </React.Suspense>
    ),
    breadcrumb: {
      label: "Registered Options",
    },
  },
  {
    path: "/registered_Intervention",
    element: (
      <React.Suspense fallback={null}>
        <ProtectedRoute>
          <RegisteredInterventionCenter />
        </ProtectedRoute>
      </React.Suspense>
    ),
    breadcrumb: {
      label: "Registered InterventionCenter",
    },
  },
  {
    path: "/ai_suggestions",
    element: (
      <React.Suspense fallback={null}>
        <ProtectedRoute>
          <AISuggestions />
        </ProtectedRoute>
      </React.Suspense>
    ),
    breadcrumb: {
      label: "AI Suggestions",
    },
  },
  {
    path: "/ai_suggestions/options",
    element: (
      <React.Suspense fallback={null}>
        <ProtectedRoute>
          <AiOptions />
        </ProtectedRoute>
      </React.Suspense>
    ),
    breadcrumb: {
      label: "AI Options",
    },
  },
  {
    path: "/waste_overview/:path",
    element: (
      <React.Suspense fallback={null}>
        <ProtectedRoute>
          <WasteOverview />
        </ProtectedRoute>
      </React.Suspense>
    ),
    breadcrumb: {
      label: "Waste Overview",
    },
  },
  {
    path: "/waste_overview/densityLoss/:path",
    element: (
      <React.Suspense fallback={null}>
        <ProtectedRoute>
          <WasteOverview />
        </ProtectedRoute>
      </React.Suspense>
    ),
    breadcrumb: {
      label: "Waste Overview",
    },
  },
   {
    path: "/pb/*",
    element: (
      <React.Suspense fallback={null}>
        <ProtectedRoute>
          <PowerBIUI />
        </ProtectedRoute>
      </React.Suspense>
    ),
    breadcrumb: {
      label: "Waste Overview",
    },
  },
  {
    path: "/Waste_Deep_Dive",
    element: (
      <React.Suspense fallback={null}>
        <ProtectedRoute>
          <PowerBIUI />
        </ProtectedRoute>
      </React.Suspense>
    ),
    breadcrumb: {
      label: "Waste Overview",
    },
  },
  {
    path: "/Country_Benchmarking",
    element: (
      <React.Suspense fallback={null}>
        <ProtectedRoute>
          <PowerBIUI />
        </ProtectedRoute>
      </React.Suspense>
    ),
    breadcrumb: {
      label: "Country",
    },
  },
  {
    path: "/waste_overview/summary",
    element: (
      <React.Suspense fallback={null}>
        <ProtectedRoute>
          <SummaryPage />
        </ProtectedRoute>
      </React.Suspense>
    ),
    breadcrumb: {
      label: "Summary",
    },
  },
  // Default routes - redirect to country-selection
  {
    path: "/",
    element: <Navigate to="/country-selection" replace />,
    exact: true,
  },
  {
    path: "*",
    element: <Navigate to="/country-selection" replace />,
    exact: true,
  },
]

const publicRoutes = [
  {
    path: "/",
    element: <Authentication />,
  },
  {
    path: "/login",
    element: <Authentication />,
  },
  {
    path: "*",
    element: <Authentication />,
  },
]

export { publicRoutes, authProtectedRoutes }